import {HttpServices} from "../Helpers";

export const GetTableColumns = async ({feature_name}) => {
  const queryList = [];
  if (feature_name) queryList.push(`feature_name=${feature_name}`);

  const result = await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/${
      process.env.REACT_APP_VERSION_API
    }/service/gridview/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const UpdateTableColumns = async ({feature_name, columns}) => {
  const result = await HttpServices.put(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/service/gridview/update`,
    {
      feature_name,
      columns,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const DynamicService = async ({
  method,
  path,
  data,
  params,
  body,
  headers,
}) => {
  let result;
  if (method === "post" || method === "put")
    result = await HttpServices[method](path, body, {
      data,
      params,
      headers,
    })
      .then((response) => response)
      .catch((error) => error.response);
  else
    result = await HttpServices[method](path, {
      data,
      params: params || body,
      headers,
    })
      .then((response) => response)
      .catch((error) => error.response);

  return result;
};
